import { render, staticRenderFns } from "./platform_notice_edit.vue?vue&type=template&id=59aff77f&scoped=true"
import script from "./platform_notice_edit.vue?vue&type=script&lang=js"
export * from "./platform_notice_edit.vue?vue&type=script&lang=js"
import style0 from "./platform_notice_edit.vue?vue&type=style&index=0&id=59aff77f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aff77f",
  null
  
)

export default component.exports